import styles from './popout-marker.css';
import React from 'react';
import { Geometry } from './popout-helpers';
import cx from 'classnames';

interface Props {
  geometry?: Geometry;
  light?: boolean;
}

export const Marker = (props: Props) => {
  const { x = 1, y = 0 } = props.geometry || {};

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2 1"
      className={cx(styles.marker, { [styles.light]: props.light })}
      style={{ top: y ? -1 : 1, order: y, alignSelf: ['flex-start', 'center', 'flex-end'][x] }}
    >
      <polygon
        className={styles.polygon}
        points={`0,${Math.abs(y - 1)} 1,${y} 2,${Math.abs(y - 1)}`}
      />
      <polyline
        className={styles.bottomLine}
        points={`0,${Math.abs(y - 1)} 2,${Math.abs(y - 1)}`}
      />
      <polyline
        className={styles.line}
        points={`0,${Math.abs(y - 1)} 1,${y} 2,${Math.abs(y - 1)}`}
      />
    </svg>
  );
};
